import { render, staticRenderFns } from "./ModalProductWidget.vue?vue&type=template&id=532c5aae&scoped=true&"
import script from "./ModalProductWidget.vue?vue&type=script&lang=js&"
export * from "./ModalProductWidget.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductWidget.vue?vue&type=style&index=0&id=532c5aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c5aae",
  null
  
)

export default component.exports